var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinWheelPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 33,
    viewBox: "0 0 64 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 33L0 0L32 5.5L64 0L32 33Z",
    fill: "url(#paint0_linear_4309_125)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4309_125",
    x1: 32,
    y1: -11,
    x2: 32,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#A3631B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFFBA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B28A33"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinWheelPointer);
export default __webpack_public_path__ + "static/media/spin-wheel-pointer.5b0f6b9f7de31bbaf162a518d8d12e99.svg";
export { ForwardRef as ReactComponent };